import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/games/games-icon.svg'
import _imports_1 from '@/assets/games/games-text.svg'


const _withScopeId = n => (_pushScopeId("data-v-40dd1c6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "ad-unit-games" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon",
      src: _imports_0
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "icon-text",
      src: _imports_1
    })
  ])
], -1))
const _hoisted_3 = { class: "card-grid" }
const _hoisted_4 = { class: "card-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_card = _resolveComponent("game-card")!
  const _component_common_section = _resolveComponent("common-section")!
  const _component_advertisement_card = _resolveComponent("advertisement-card")!
  const _component_layout_footer = _resolveComponent("layout-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "games-container",
      style: _normalizeStyle(_ctx.cssProps)
    }, [
      _hoisted_2,
      _createVNode(_component_game_card, {
        class: "game-card max-width",
        label: _ctx.t('games.staff-pick'),
        type: "highlighted",
        game: _ctx.trendingGame
      }, null, 8, ["label", "game"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gamesByCategoryFirst, (cat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: cat.name,
          class: "category-wrapper"
        }, [
          _createVNode(_component_common_section, {
            class: "c-section",
            colorLeft: _ctx.mainColor,
            colorRight: _ctx.secondaryColor,
            text: cat.name
          }, null, 8, ["colorLeft", "colorRight", "text"]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.games, (game) => {
              return (_openBlock(), _createBlock(_component_game_card, {
                key: game.id,
                class: "grid-card",
                type: "image",
                game: game
              }, null, 8, ["game"]))
            }), 128))
          ])
        ]))
      }), 128)),
      _createVNode(_component_advertisement_card, {
        spot: _ctx.adSpotMiddle,
        class: "a-card-grid max-width"
      }, null, 8, ["spot"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gamesByCategorySecond, (cat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: cat.name,
          class: "category-wrapper"
        }, [
          _createVNode(_component_common_section, {
            class: "c-section",
            colorLeft: _ctx.mainColor,
            colorRight: _ctx.secondaryColor,
            text: cat.name
          }, null, 8, ["colorLeft", "colorRight", "text"]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.games, (game) => {
              return (_openBlock(), _createBlock(_component_game_card, {
                key: game.id,
                class: "grid-card",
                type: "image",
                game: game
              }, null, 8, ["game"]))
            }), 128))
          ])
        ]))
      }), 128)),
      (_ctx.pageReady)
        ? (_openBlock(), _createBlock(_component_layout_footer, {
            key: 0,
            spot: _ctx.adSpotFooter
          }, null, 8, ["spot"]))
        : _createCommentVNode("", true)
    ], 4)
  ], 64))
}